module.exports = __webpack_public_path__ + "static/langojango-swedish-language-phrasebook-690f182d90acc9af86ecdb02f9ea25c8.png";